import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const DZIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="DZ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M8 0h8v12H8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#36A400"
        fillRule="evenodd"
        d="M0 0h8v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="red"
        d="M8.019 2.165c1.3 0 2.462.583 3.243 1.5a3.762 3.762 0 0 0-1.952-.539c-1.986 0-3.596 1.505-3.596 3.36 0 1.856 1.61 3.36 3.596 3.36.618 0 1.2-.146 1.709-.403a4.258 4.258 0 1 1-3-7.278Zm2.59 3.8L12 6.464l-1.391.597v1.543l-.852-1.33-1.559.561.824-1.371-.824-1.288 1.486.409 1.034-1.172-.11 1.552Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
